var $2eab88da6eb0edda$exports = {};
$2eab88da6eb0edda$exports = {
    "collapse": `\u{637}\u{64A}`,
    "expand": `\u{62A}\u{645}\u{62F}\u{64A}\u{62F}`
};


export {$2eab88da6eb0edda$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
